/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Data_Write_Grant_AllowInputs */



/**
* | output |
* | --- |
* | "Allow" |
*
* @param {Canvas_Data_Write_Grant_AllowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_data_write_grant_allow = /** @type {((inputs?: Canvas_Data_Write_Grant_AllowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Data_Write_Grant_AllowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erlauben")
	return /** @type {LocalizedString} */ ("Allow")
});